import { stripHtml } from "./Utils.js";

class CsvExporter {
    constructor(data, filename = "exported.csv") {
        this.data = data;
        this.filename = filename;
    }

    // convert the data to CSV format
    convertToCsv() {
        const rows = this.data.map((row) =>
            Object.values(row)
                .map((value) => `"${value}"`)
                .join(","),
        );
        return rows.join("\n");
    }

    exportToCsv(customFilename) {
        // set filename to customFilename if it is provided, otherwise use the default filename
        // replace spaces with dashes in the filename and add the .csv extension
        const filenameToUse = customFilename
            ? customFilename.replace(/ /g, "-") + ".csv"
            : this.filename;

        // create a blob object from the csv string
        const csvContent = this.convertToCsv();
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = filenameToUse;
        a.style.display = "none";
        document.body.appendChild(a);
        // send the download request
        a.click();

        // clean up
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
}

export async function exportTopicToCsv(data, customFilename) {
    // map the data to the format we want
    let topicData = await data.snippets?.map((row) => {
        // "Snippet Title": "Sample Snippet 1",
        // "Snippet Content": "This is the content of sample snippet 1.",
        // "Creation Date": "2023-09-20",
        // "Author": "John Doe",
        // "Tags": "javascript, programming, code",
        // "URL": "https://example.com/snippet1"
        let title = row.name ?? " ";
        let content = row.content ? stripHtml(row.content) : " ";
        let createdOn = row.createdOn
            ? new Date(row.createdOn).toLocaleDateString()
            : " ";
        let author = row.createdBy?.username ?? " ";
        let tags = row.tagsList?.trim() ?? " ";
        let url = row.url ?? " ";

        return {
            "Snippet Title": title,
            "Snippet Content": content,
            "Creation Date": createdOn,
            Author: author,
            Tags: tags,
            URL: url,
        };
    });

    // add the header row
    const headerRow = {
        "Snippet Title": "Title",
        "Snippet Content": "Content",
        "Creation Date": "Creation Date",
        Author: "Author",
        Tags: "Tags",
        URL: "URL",
    };

    // combine the header row with the data rows
    topicData = [headerRow, ...topicData];

    // export the data to a CSV file and download it
    const exporter = new CsvExporter(topicData, customFilename);
    exporter.exportToCsv(customFilename);
}
